import * as mailAccount from "./mailAccount";
import * as mailFacadeImpl from "./mailFacadeImpl";

export const mail = {
  mailAccount,
  mailFacadeImpl,
};
